// extracted by mini-css-extract-plugin
export var questionnairerequest = "style-module--questionnairerequest--SJML6";
export var questionnairerequest_title = "style-module--questionnairerequest_title--UzD9z";
export var questionnairerequest_lead = "style-module--questionnairerequest_lead--7YnfU";
export var questionnairerequest_description = "style-module--questionnairerequest_description--xmeLV";
export var questionnairerequest_image = "style-module--questionnairerequest_image--t55qh";
export var questionnairerequest_notice = "style-module--questionnairerequest_notice--bcTm0";
export var questionnairerequest_buttons = "style-module--questionnairerequest_buttons--SBxKB";
export var image = "style-module--image--qO1iG";
export var image_1 = "style-module--image_1--EWKwV";
export var buttons = "style-module--buttons--5QCK6";
export var buttons_item = "style-module--buttons_item--vkr56";
export var button = "style-module--button--o3Wf6";
export var button_icon = "style-module--button_icon--sIwQw";
export var button_text = "style-module--button_text--3T7+J";